import { FormFieldDefinition } from '../../../../../../generic/universal-table/types/form.types'
import { CarUiRow } from '../types/carTable.types'

export const carTableFormFields: FormFieldDefinition<CarUiRow>[] = [
  {
    name: 'CarNum',
    label: 'מספר רכב',
    inputType: 'number',
    required: false,
    defaultValue: 0,
    validationRules: { min: 0 },
  },
  {
    // getOptions is injected in CarTableModule.tsx
    name: 'FreightCompanyID',
    label: 'חברת הובלה',
    inputType: 'searchable-select',
    required: false,
  },
  {
    // getOptions is injected in CarTableModule.tsx
    name: 'DriverWorkerId',
    label: 'עובד נהג',
    inputType: 'searchable-select',
    required: false,
  },
  {
    name: 'DriverName',
    label: 'שם נהג',
    inputType: 'text',
    required: false,
    placeholder: 'שם נהג',
    validationRules: {
      maxLength: 100,
    },
  },
  {
    name: 'Phone',
    label: 'טלפון',
    inputType: 'text',
    required: false,
    placeholder: 'טלפון',
    validationRules: {
      maxLength: 50,
    },
  },
  {
    name: 'DriverID',
    label: 'מזהה נהג',
    inputType: 'number',
    required: false,
    defaultValue: 0,
    validationRules: { min: 0 },
  },
  {
    name: 'Max_Weight',
    label: 'משקל מקסימלי',
    inputType: 'number',
    required: false,
    defaultValue: 0,
    validationRules: { min: 0 },
  },
  {
    name: 'Pallets',
    label: 'משטחים',
    inputType: 'number',
    required: false,
    defaultValue: 0,
    validationRules: { min: 0 },
  },
  {
    name: 'EmptyTrackWght',
    label: 'משקל רכב ריק',
    inputType: 'number',
    required: false,
    defaultValue: 0,
    validationRules: { min: 0 },
  },
  {
    name: 'Active',
    label: 'פעיל',
    inputType: 'boolean-select',
    required: false,
    defaultValue: true,
  },
  {
    name: 'IsChargeHovala',
    label: 'חיוב הובלה',
    inputType: 'boolean-select',
    required: false,
    defaultValue: false,
  },
]
